import React from 'react'

import {ProjectSystemType} from "../../../../../core/model2/project/types"
import ControlShowInProjectsTree from "../../../../../core/gd-app/component/quick-links/aim"
import AddView from "../submenu/add-view/add-view"
import ToggleSubmenuButton from "../submenu/toggle-button/toggle-button"
import MoreButton_Project from "../../../../../core/gd-ui/more/project/more-button"
import {MoreButtonType} from "../../../../../core/gd-ui/more/types"
import CompactViewSelector from "../compact-view-selector/compact-view-selector"
import ProjectSession from "../../../../../core/model2/project/project-session"

type Props = {
    project: ProjectSession
}

// const debug = "CompactTopProject"
const debug = false

export default function CompactTopProject(props: Props) {
    debug && console.log(debug, 'CompactTopProject', props)

    switch (props.project.systemType) {
        case ProjectSystemType.PAGE:
        case ProjectSystemType.WHITEBOARD:
        case ProjectSystemType.EMBED:
        case ProjectSystemType.SINGLE_VIEW_TODOS:
        case ProjectSystemType.SINGLE_VIEW_GOALS:
        case ProjectSystemType.SINGLE_VIEW_FILES:
        case ProjectSystemType.SINGLE_VIEW_MEETINGS:
        case ProjectSystemType.SINGLE_VIEW_EXPENSES:
        case ProjectSystemType.SINGLE_VIEW_CHATS:
        case ProjectSystemType.SINGLE_VIEW_TASK_LIST:
        case ProjectSystemType.SINGLE_VIEW_TASK_BOARD:

            return (
                <>
                    <ControlShowInProjectsTree className = "m-l-10 m-r-5"
                                               project   = {props.project} />

                    {props.project.acl.canAddView &&
                        <AddView className = "project-add-view m-r-5" projectId = {props.project.id}/>
                    }

                    <ToggleSubmenuButton className = "project-submenu-toggle m-r-5"/>

                    <MoreButton_Project project={props.project} buttonType={MoreButtonType.CONTROL_BUTTON_S28} className="project-more" />
                </>
            )

        case ProjectSystemType.LINK:
            return (
                <>
                    <ControlShowInProjectsTree className = "m-l-10 m-r-5"
                                               project   = {props.project} />
                    <MoreButton_Project project={props.project} buttonType={MoreButtonType.CONTROL_BUTTON_S28} className="project-more" />
                </>
            )

        default:
            return (
                <>
                    <CompactViewSelector project={props.project} />

                    <ToggleSubmenuButton className = "project-submenu-toggle m-l-10"/>
                    <ControlShowInProjectsTree className = "m-l-5"
                                               project   = {props.project} />
                </>
            )
    }
}
